import {route} from "@lernetz/ts-lib";
import {Gateway} from "@lernetz/ts-lib/src/Gateway";
import {ToolModel} from ".";
import {Carousel} from "../components/article-elements/carousel/Carousel";
import {DecoratedIframely} from "../components/article-elements/decoratedIframely/DecoratedIframely";
import {MaterialList} from "../components/article-elements/materiallist/MaterialList";
import {RawHtml} from "../components/article-elements/rawhtml/RawHtml";
import {PersonalImpact} from "../components/article-elements/personal-impact/PersonalImpact";
import {RelatedContent} from "../components/article-elements/related-content/related-content.component";
import {Toggle} from "../components/article-elements/toggle/Toggle";


export class ToolGateway extends Gateway {
    routeBase = "api.tools";
    constructor(config) {
        super(config);
        this.in.add('App\\Tool', dto => new ToolModel(dto))
        this.in.add( "App\\IFrame", ( dto ) => new DecoratedIframely( dto ) );
        this.in.add( "App\\Toggle", ( dto ) => new Toggle( dto ) );
        this.in.add( "App\\Carousel", ( dto ) => new Carousel( dto ) );
        this.in.add( "App\\MaterialList", ( dto ) => new MaterialList( dto ) );
        this.in.add( "App\\RawHtml", ( dto ) => new RawHtml( dto ) );

        // extraInfos
        this.in.add( "App\\PersonalImpact", ( dto ) => new PersonalImpact( dto ) );
        this.in.add( "App\\RelatedContent", ( dto ) => new RelatedContent( dto ) );
    }
    async feed() {
        const tool = await route(`api.feed`).load() as { data: any};
        return this.in.transform(tool.data);
    }
    async get(id) {
        const tool = (await route(`${this.routeBase}.details`, { tool: id }).load() as any).data;
        return this.in.transform(tool);
    }
    async loadFilteredTools(filterQuery: string) {
        // return route(`${this.routeBase}`)
        const url =  filterQuery ? `/api/tools${filterQuery}` : `/api/tools`;
        return fetch(url).then(res => res.json()).then(res => res.data);
    }
}
